import type { RadioItemType } from './radio.types';

/** Plik znaleziony w `public/` przez plugin `radioCatalog.vite.ts`. */
export interface RadioCatalogFile {
  src: string;
  type: RadioItemType;
  /** Podfoldery, w których leży plik (np. `["night"]`). */
  tags?: string[];
  title?: string;
  artist?: string;
}

/** Lista plików audio wstrzyknięta przy starcie dev/build (pusta, gdy plików brak). */
export const RADIO_CATALOG_FILES: readonly RadioCatalogFile[] =
  typeof __RADIO_CATALOG_FILES__ === 'undefined' ? [] : __RADIO_CATALOG_FILES__;
